const handle = {
  handleSurgeryList: (data) => {
    const values = {
      surgeryList: [],
      surgeryListIndex: []
    };
    if (data.is_operation === 2) {
      const list = data.list.map (i => ({
        card_id: i.id,
        time: i.operation_date,
        parts: [{ id: i.operative_site_id, name: i.operative_site_name }],
      }));
      values.surgeryType = [{ name: "有过", id: 2 }];
      values.surgeryList = values.surgeryList.concat (JSON.parse (JSON.stringify ([...list])));
      values.surgeryListIndex = values.surgeryListIndex.concat (JSON.parse (JSON.stringify ([...list])));
    } else {
      values.surgeryType = [{ name: "没有", id: 1 }];
      values.surgeryList = [];
      values.surgeryListIndex = [];
    }
    return values;
  },
  handleOtherHistory: (data) => {
    const values = { habit: data.is_operation };
    if (data.is_operation !== 1) {
      values.years = `${data.years}`;
      values.frequency = `${data.frequency}`;
    } else {
      values.years = "";
      values.frequency = "";
    }
    return values;
  }
};
export default handle;
